import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

const OpeningHoursTodayFormatted = ({
  labelKey,
  businessHoursToday,
}: {
  labelKey: string;
  businessHoursToday: {
    closed: boolean;
    openFrom: string;
    openTill: string;
  };
}) => {
  const i18n = useI18nContext();

  if (businessHoursToday && !businessHoursToday.closed && businessHoursToday.openFrom && businessHoursToday.openTill) {
    return (
      <span>
        {i18n.t(labelKey, {
          openFrom: businessHoursToday.openFrom,
          openTill: businessHoursToday.openTill,
        })}
      </span>
    );
  }
  return <span>{i18n.t('sellerProfile.businessHours.todayClosed')}</span>;
};

export default OpeningHoursTodayFormatted;
